import { Close } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import FallbackComponent from "../../../../components/fallbackComponent/FallbackComponent";
import { OutboundDeliveryOverviewFragment } from "../../../../models/autogenerated-deliveryService-gql/graphql";
import OutboundDeliveryCard from "../outboundDeliveryCard/OutboundDeliveryCard";

interface OutboundDeliveryTableProps {
  items: OutboundDeliveryOverviewFragment[];
}

const OutboundDeliveryTable = (props: OutboundDeliveryTableProps) => {
  const { t } = useTranslation();
  const { items } = props;

  const emptyListIcon = <Close size={32} />;
  const emptyListText = t("noDeliveriesExist");

  if (items.length === 0) {
    return (
      <FallbackComponent middleIcon={emptyListIcon} text={emptyListText} />
    );
  }

  return (
    <div className="table-container">
      <div className="card-list">
        {items.map((delivery) => (
          <OutboundDeliveryCard key={delivery.id} delivery={delivery} />
        ))}
      </div>
    </div>
  );
};

export default OutboundDeliveryTable;
